<template>
  <div class="c_atom_accordion">
    <slot />
  </div>
</template>

<script>
import { defineComponent } from '@nuxtjs/composition-api';

export default defineComponent({
  name: 'Accordion',
});
</script>
